import styled from "styled-components";

export const SubTitle = styled.p`
  margin-bottom: 18px;
`;

export const FieldRow = styled.div`
  position: relative;
`;

export const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  gap: 16px;
`;
